/**
 * Parallaxe légère d'un visuel (téléphone du hero, écran de stats…) sur les
 * pages produit « à la Apple » (refonte /dashboard, Karim 2026-10-18).
 *
 * Le visuel glisse verticalement de `facteur` × sa distance au centre de
 * l'écran : négatif = il remonte plus vite que la page. Un seul calcul par
 * image (requestAnimationFrame), écouteur passif, rien côté serveur, et
 * rien du tout si `prefers-reduced-motion: reduce`.
 */
export function useParallaxLeger(cible: Ref<HTMLElement | null>, facteur: number) {
  let enAttente = false;

  function appliquer() {
    enAttente = false;
    const el = cible.value;
    if (!el) return;
    const r = el.getBoundingClientRect();
    const decalage = (r.top + r.height / 2 - window.innerHeight / 2) * facteur;
    el.style.transform = `translate3d(0, ${decalage.toFixed(1)}px, 0)`;
  }

  function surDefilement() {
    if (enAttente) return;
    enAttente = true;
    requestAnimationFrame(appliquer);
  }

  onMounted(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    window.addEventListener("scroll", surDefilement, { passive: true });
    appliquer();
  });

  onBeforeUnmount(() => window.removeEventListener("scroll", surDefilement));
}
